<template>
  <div class="say_hello">
    <van-field
    class="say_hello_input"
    v-model="content"
    type="textarea"
    placeholder="打声招呼吧~"
    maxlength="500"
    rows="4"
    show-word-limit 
  />
  <div class="checked_wrap" v-if="userInfo.inMember.userRole == 'Exhibitor'">
    <van-checkbox van-checkbox v-model="checkShop">邀请参观店铺</van-checkbox>
    <van-checkbox van-checkbox v-model="checkLive">邀请参观店铺</van-checkbox>
  </div>
  <div class="btn-bg">
    <div class="btn" @click="submitRelease">
      <span>发送</span>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import gql from 'graphql-tag'
export default {
  name: "say-hello",
  components: {},
  data() {
    return {
      content: "",
      checkShop:false,
      checkLive:false,
      majorList:null, // 接收打招呼人的信息

    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
    toId(){
      return this.$route.query.id;
    },
    MemberGql(){
        return gql `query
                member($id:Guid!){
                    member(id:$id){
                      avatarUrl
                      company
                      id
                      jobTitle
                      name
                      nickName
                      phone
                      province
                      userId
                      inMember(exhibitionId:"${this.exhibitionId}"){
                        id
                      }
                    }
                }`
    },
  },
  created() {
    this.getMember();
  },
  methods: {
    ...mapActions({
      SayHello:'follower/SayHello',
    }),
    getMember(){
      this.$apollo.addSmartQuery("member",{
                query:this.MemberGql,
                variables:{
                    id:this.toId
                },
                fetchPolicy:'network-only',  // 清除缓存的数据，重新获取服务器数据
                result(res){
                    let data = JSON.parse(JSON.stringify(res));
                    if(data&&data.data.member){
                      let c = data.data.member;
                      this.majorList = c;
                    }
                },
                error(error) {
                    console.error(error,'error错误处理')
                }
            })
    },
    // 打招呼
    async submitRelease() {
      console.log(this.content)
      if (!this.content) {
        this.$toast.fail("请输入打招呼内容");
        return;
      }
      if (/.*1[3|4|5|7|8][0-9]{9}.*/.test(this.content)) {
        this.$toast.fail("不能包含手机号");
        return;
      } 
      let list={
        To:{
          AvatarUrl:this.majorList.avatarUrl,
          Name:this.majorList.name,
          JobTitle:this.majorList.jobTitle,
          CompName:this.majorList.company,
          Title:this.majorList.title,
        },
        From:{
          AvatarUrl:this.userInfo.avatarUrl,
          Name:this.userInfo.name,
          JobTitle:this.userInfo.jobTitle,
          CompName:this.userInfo.company,
          Title:this.userInfo.title,
          Phone:this.userInfo.phone || '',
          // RoomName:this.roomTitle,
          UserRole:this.userInfo.inMember.userRole
        }
      }
      let matedata=JSON.stringify(list);
      let body = {};
      if(this.userInfo.inMember.userRole == 'Exhibitor') { // 展商

      } else { // 普通身份
        body = {
          exhibitionId:this.exhibitionId,
          matedata: matedata,
          fromId: this.userInfo.inMember.id,
          toId: this.majorList.inMember.id,
          content: this.content,
        }
      }
      const res = await this.SayHello(body);
      if(res.result){
        this.$toast.success('提交成功');
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      } else {
        this.$toast.fail(res.message)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.say_hello {
  width: 100%;
  background-color: #f5f5f5;
  min-height: 100vh;
  padding:0.3rem 0.24rem 0.98rem;
  .say_hello_input{
    border-radius: 0.05rem;
    background: #fff;
    overflow: hidden;
  }
  .checked_wrap{
    margin-top: 0.4rem;
    .van-checkbox{
      background: #fff;
      height: 0.88rem;
      display: flex;
      align-items: center;
      padding-left: 0.2rem;
      border-radius: 0.05rem;
      margin-bottom: 0.2rem;
      .van-checkbox__label{
        font-size: 0.26rem;
        color: #333;
      }
      &:last-child{
        margin-bottom: 0rem;
      }
    }
  }
}

.btn-bg {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0.98rem;
  width: 100%;
  text-align: center;
  .btn {
    width: 6.5rem;
    height: 0.78rem;
    background-color: #1890ff;
    border-radius: 0.37rem;
    border: solid 2px #1890ff;
    margin: 0 auto;
    margin-top: 0.1rem;
    span {
      color: #fff;
      font-size: 0.3rem;
      line-height: 0.78rem;
    }
  }
}
</style>
